import React from 'react';
import { Loader } from 'UI';
import ovStl from './overlay.css';
export default function OverlayLoader() {
    return React.createElement("div", { className: ovStl.overlay },
        React.createElement(Loader, { loading: true }));
}
